import { forwardRef } from 'react';

export const ConsentForm = forwardRef<HTMLDivElement>((props, ref) => (
  <div className="overflow-hidden w-full h-screen" ref={ref} {...props} />
));

ConsentForm.displayName = 'ConsentForm';
